import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import usePublicAppConfig from '../../hooks/usePublicAppConfig';

import './styles.scss';

const getTickerText = (item) =>
	String(item?.description || item?.content || item?.title || '').trim();

const buildTickerMessages = (text) =>
	Array.from({ length: 4 }, (_, index) => ({
		id: `${text}-${index}`,
		text,
	}));

const AppInformationTicker = ({ className, items }) => {
	const publicAppConfig = usePublicAppConfig({ enabled: !items });
	const sourceItems = items || publicAppConfig.appInformationItems || [];

	const tickerText = useMemo(() => {
		return sourceItems
			.filter(
				(item) =>
					item?.enabled !== false &&
					item?.informationType === 'ticker' &&
					getTickerText(item)
			)
			.map(getTickerText)
			.join('   |   ');
	}, [sourceItems]);
	const tickerMessages = useMemo(
		() => (tickerText ? buildTickerMessages(tickerText) : []),
		[tickerText]
	);

	if (!tickerText) return null;

	return (
		<div className={clsx('app-information-ticker', className)} role="status">
			<div className="app-information-ticker__viewport">
				<div className="app-information-ticker__track">
					<div className="app-information-ticker__group">
						{tickerMessages.map((message) => (
							<span key={message.id}>{message.text}</span>
						))}
					</div>
					<div className="app-information-ticker__group" aria-hidden="true">
						{tickerMessages.map((message) => (
							<span key={`duplicate-${message.id}`}>{message.text}</span>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

AppInformationTicker.defaultProps = {
	className: '',
	items: null,
};

AppInformationTicker.propTypes = {
	className: PropTypes.string,
	items: PropTypes.arrayOf(PropTypes.shape({})),
};

export default AppInformationTicker;
